<script setup>
import Vue, {reactive, ref} from "vue";
import useForm from "@/composables/useForm";
import userService from "@/services/user.service";

const emit = defineEmits(['closed']);

const form = reactive({
    password: '',
    oldPassword: '',
    confirmPassword: ''
});

const {resetForm, errors, hasErrors, clearErrors} = useForm(form);

const showModal = ref(false);
const loading = ref(false);

async function save() {
    loading.value = true;
    clearErrors();

    const {data} = await userService.changePassword(form);

    loading.value = false;

    if (!hasErrors(data)) {
        showModal.value = false;

        Vue.notify({
            group: 'app',
            type: 'success',
            duration: 5000,
            text: 'The password has been changes successfully'
        })
    }
}

function open() {
    resetForm();
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <Modal v-model="showModal" size="md" title="Change Password" @hide="emit('closed')">
        <template #modal-title>
            <div class="d-flex align-items-baseline">
                <h4 class="heading4 mb-0 mr-4">Change Password</h4>
            </div>
        </template>

        <h5 class="heading5 heading5--secondary">Current password</h5>
        <div class="form form-modal mb-4">
            <div v-if="errors.oldPassword.length" class="error text-right">{{ errors.oldPassword[0] }}</div>
            <input
                type="password"
                class="form-control form-control--mid"
                autocomplete="new-password"
                v-model="form.oldPassword"
            />
        </div>

        <h5 class="heading5 heading5--secondary">New Password</h5>
        <div class="form form-modal mb-4">
            <div v-if="errors.password.length" class="error text-right">{{ errors.password[0] }}</div>
            <input
                type="password"
                class="form-control form-control--mid"
                autocomplete="new-password"
                v-model="form.password"
            />
        </div>

        <p style="font-size: 14px">
            Password must be at least eight characters long, contain uppercase and lowercase letters and numbers
        </p>

        <h5 class="heading5 heading5--secondary">Confirm New Password</h5>
        <div class="form form-modal mb-4">
            <div v-if="errors.confirmPassword.length" class="error text-right">{{ errors.confirmPassword[0] }}</div>
            <input
                type="password"
                class="form-control form-control--mid"
                autocomplete="new-password"
                v-model="form.confirmPassword"
            />
        </div>

        <template #modal-footer>
            <PrimaryButton
                :loading="loading"
                @click="save"
            >
                Change Password
                <template #loading>
                    Saving...
                </template>
            </PrimaryButton>
        </template>
    </Modal>
</template>

<style scoped>

</style>
